import { relative } from 'path';
import React from 'react';
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  UncontrolledDropdown,
} from 'reactstrap';

const DashBoardDropdown = ({
  width,
  height,
  options,
  value,
  setValue,
}: {
  width?: string;
  height?: string;
  options?: {
    value: string;
    label: string;
  }[];
  value: string;
  setValue: React.Dispatch<React.SetStateAction<string>>;
}) => {
  return (
    <div style={{ position: 'relative' }}>
      <UncontrolledDropdown
        style={{
          width: width ? width : 'auto',
          height: height ? height : 'auto',
        }}
      >
        <DropdownToggle caret>{value}</DropdownToggle>
        <DropdownMenu>
          {options?.map((item) => (
            <DropdownItem key={item.value} onClick={() => setValue(item.value)}>
              {item.label}
            </DropdownItem>
          ))}
        </DropdownMenu>
      </UncontrolledDropdown>
      <div className="dropdown-icon-container">
        <img width={24} height={24} src="/assets/select-down.svg" alt="" />
      </div>
    </div>
  );
};

export default DashBoardDropdown;
